import { useFirestoreNoCompagny } from '../../firebase/useFirestore'

const FieldMeta = ({item}) => {

    const fields = useFirestoreNoCompagny('QuestionnaireFields', 'ID', item || '')

    return (
      <>
          {fields && fields.map((item) => (
              <p>{item.Question}</p>
          ))}
      </>
    )
}

export default FieldMeta